import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { ProfessionalRfpQuestionListView } from '@/components/pages/rfp/professional/ProfessionalRfpQuestionListView';
import Layout from '@/container/Layout';
import { useRfpProfessionalQuestionListPage } from '@/pages/rfp/professional/RfpProfessionalQuestionList/useRfpProfessionalQuestionListPage';
import { useRfpProfessionalQuestionListUpdateUnread } from '@/pages/rfp/professional/RfpProfessionalQuestionList/useRfpProfessionalQuestionListUpdateUnread';
import { useMemoFrozen } from '@/utils/hooks/useMemo/useMemoFrozen';
import { parseQuery, getParsedQueryString, } from '@/utils/libs/query-string/parse';
const title = '質問一覧';
export const RfpProfessionalQuestionListPage = (props) => {
    const { question, rfp } = props;
    const { id, name } = rfp;
    const { can_add_question_count: canAddQuestionCount, is_can_add_question: isCanAddQuestion, online_questions: onlineQuestions, } = question;
    // URLの質問ID取得
    const { search } = useLocation();
    const questionId = useMemoFrozen(() => {
        const query = parseQuery(search);
        return getParsedQueryString(query.id);
    });
    // データをコンポーネントに渡す値に変更する
    const { isDisclose, isDiscloseApproved, questionItems } = useRfpProfessionalQuestionListPage({ onlineQuestions, rfp });
    // 未読状態の更新
    useRfpProfessionalQuestionListUpdateUnread({ id, onlineQuestions });
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${title} | Proffit` }) }), _jsx(ProfessionalRfpQuestionListView, { canAddQuestionCount: canAddQuestionCount, id: id, isCanAddQuestion: isCanAddQuestion, isDisclose: isDisclose, isDiscloseApproved: isDiscloseApproved, name: name, questionId: questionId, questionItems: questionItems, title: title })] })));
};
